<template>
  <div class="layout-padding">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      :title="$route.query.title + ' 게시글 조회'"
      desc="해당 게시물들의 연관 상품을 관리 할수있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1100"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="created_time" slot-scope="props">
        {{ convertDate(props.item.created_time, 'datetime') }}
      </div>

      <div slot="product_list" slot-scope="props" style="text-align:left">
        <div v-for="(product, idx) in props.item.product_list" :key="`product-${idx}`" class="flex" style="align-items: center">
          <div :style="imgField(product.first_img)" v-if="product.first_img"></div>
          <span style="max-width:130px">{{ product.name }}</span>
          <span v-if="idx < props.item.product_list.length-1">,</span></div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button" @click.stop.prevent="clickItem(props.item,'update')">수정</button>
      </div>
    </admin-table>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import AdminFilter from "../../module/admin/AdminFilter";
  import AdminTable from "../../module/admin/AdminTable";

  export default {
    name: 'PostMappingList',
    layout: "Main",
    mixins: [
      ListMixin
    ],
    components: {
      AdminTable,
      AdminFilter
    },
    created() {
      this.init();
    },
    data() {
      return {}
    },
    watch: {
      '$route'(n){
        this.initializing('post_mapping', 'board/' +this.$route.params.id + '/mapping');
      }
    },
    methods: {
      init() {
        this.initializing('post_mapping', 'board/' +this.$route.params.id + '/mapping');
      },
      getDataFromServer() {
        this.getData();
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 20px; height: 20px; background-size: cover;' +
          ' background-position: center; margin-right: 8px';
      },
      clickItem(item, kind) {
        if (kind === "update") {
          let title = '';
          if(this.$route.query.title){
            title = '&title='+this.$route.query.title;
          }
          this.$router.push('mapping/create?id=' + item.id+title);
        }
      }
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  ////@import '~assets/css/reset';
  //@import '~assets/css/lp_main';

  .tr-whole-border th {
    padding: 12px 6px;
  }

  .many-field-tr td {
    padding: 6px;
  }

  .progress-btn {
    border-radius: 3px;
    display: inline-block;
    width: 84px;
    padding: 6px 0;
    margin: 2px;
    font-weight: bold;
    font-size: 0.8rem;
  }

  .btn-confirm-new-req {
    background-color: #ffb100;
    color: #fff;
  }

  .btn-stand-by-ests {
    color: #064160;
    font-weight: bold;
  }

  .btn-write-sheet {
    background-color: $primary;
    color: #fff;
  }

  .bid-state {
    margin: 2px 0;
    color: #fff;
    border-radius: 3px;
    display: inline-block;
    width: 76px;
    padding: 4px;
  }

  .bid-state-ing {
    background-color: #1c7cd5;
  }

  .bid-state-ok {
    background-color: #5cb85c;
  }

  .bid-state-no {
    background-color: #f0ad4e;
  }
</style>
